define('boxes/helpers/tooltip',['jquery','all/jquery/jquery.tooltip'], function($) {
    'use strict';

    var ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-error';
    var DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-dynamic-error';

    function showError(element) {
        var $element = $(element);
        var errorMessage = $element.data(ERROR_MESSAGE_DATA_ATTRIBUTE);
        if ($element.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE) !== undefined) {
            errorMessage = $element.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
        }
        showPopover($element, errorMessage);
    }

    function showPopover(element, message) {
        var $element = $(element);
        $element.popover('destroy');
        $element.popover({
            content: message,
            container: $element,
            html: true,
            trigger: 'manual'
        }).popover('show');
    }

    function hidePopover(element) {
        var $element = $(element);
        $element.popover('destroy');
    }

    var tooltip  = {};
    tooltip.showError = showError;
    tooltip.showPopover = showPopover;
    tooltip.hidePopover = hidePopover;
    return tooltip;
});
